<template>
    <b-modal v-if="!loading" id="unit_form" ref="unit_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Unit' : 'Edit Unit' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-row v-if="validationError">
            <b-colxx md="12">
                <b-alert class="text-center" show variant="danger"
                         v-text="validationError"/>
            </b-colxx>
        </b-row>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facilities" class="has-float-label">
                        <template v-slot:label>
                            <span>Facilities <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Floors" class="has-float-label">
                        <template v-slot:label>
                            <span>Floors <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFloor" v-model="selected.floor" :options="floors"
                                  :border-danger="'floor_id' in errors"/>

                        <b-form-invalid-feedback :state="!'floor_id' in errors"
                                                 v-text="'floor_id' in errors ? errors.floor_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Registered At" class="has-float-label">
                        <template v-slot:label>
                            <span>Registered At <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-align="right" popover-visibility="focus" mode="single"
                            v-model="datepicker.registered_at"
                            @input="'registered_at' in errors ? delete errors.registered_at : ''"
                            :input-props="{ class:'form-control' + ('registered_at' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'registered_at' in errors"
                                                 v-text="'registered_at' in errors ? errors.registered_at[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('unit_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitUnit">Submit</state-button>

            <state-button v-else variant="primary" :click="updateUnit">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../../components/Common/StateButton";
import moment from "moment";

export default {
    name: "UnitFormModal",

    components: {
        StateButton,
    },

    props: [
        'edit',
    ],

    data() {
        return {
            loading: true,
            datepicker: {
                registered_at: null,
            },
            selected: {
                facility: [],
                floor: [],
            },
            validationError: null,
        }
    },

    computed: {
        ...mapGetters({
            form: 'getUnitForm',
            errors: 'getUnitErrors',
            facilities: 'getSelectFacilities',
            floors: 'getSelectFloors'
        }),
    },

    watch: {
        form() {
            if (this.edit) {
                this.datepicker.registered_at = moment(this.form.registered_at).toDate();

                this.selected.facility = this.form.select_facility;
                this.selected.floor = this.form.select_floor;
            }
        },

        'datepicker.registered_at'(registered_at) {
            if (moment(registered_at).format('YYYY-MM-DD') === 'Invalid date') return this.form.registered_at = null;
            this.form.registered_at = moment(registered_at).format('YYYY-MM-DD');
        }
    },

    mounted() {
        this.getFormData();
    },

    methods: {
        resetForm() {
            this.$store.commit('setUnitForm');

            this.selected.facility = [];
            this.selected.floor = [];
            this.datepicker = {
                registered_at: null,
            };
        },

        updateFacility(field) {
            if (field) {
                this.form.facility_id = field.facility_id;
                this.$store.dispatch('fetchSelectFloors', field.facility_id);
            } else {
                this.form.facility_id = '';
            }
            'facility_id' in this.errors ? delete this.errors.facility_id : '';
        },

        updateFloor(field) {
            if (field) {
                this.form.floor_id = field.floor_id;
            } else {
                this.form.floor_id = '';
            }
            'floor_id' in this.errors ? delete this.errors.floor_id : '';
        },

        async getFormData() {
            await this.$store.dispatch('fetchSelectFacilities');

            return this.loading = false;
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitUnit() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitUnit', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new unit!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('unit_form');
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.validationError = error.response.data.error;
                        }

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateUnit() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateUnit', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the unit!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('unit_form');
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.validationError = error.response.data.error;
                        }

                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    },
}
</script>

<style scoped>

</style>
